import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=04e2abdb&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=04e2abdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2abdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e2abdb')) {
      api.createRecord('04e2abdb', component.options)
    } else {
      api.reload('04e2abdb', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=04e2abdb&scoped=true&", function () {
      api.rerender('04e2abdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/Chat.vue"
export default component.exports